import './directives/bindPolymer.js';
import './directives/blinker.js';
import './directives/capitalize.js';
import './directives/displayErrors.js';
import './directives/expiredMonth.js';
import './directives/expiredYear.js';
import './directives/filterExpirationYear.js';
import './directives/flash.js';
import './directives/focus.js';
import './directives/ibanValidator.js';
import './directives/include.js';
import './directives/integer.js';
import './directives/maskInvalid.js';
import './directives/mobilePhoneNumber.js';
import './directives/modalDialog.js';
import './directives/onblur.js';
import './directives/replaceDashes.js';
import './directives/selectOnClick.js';
import './directives/serverValidate.js';
import './filters/nsFilters.js';
import './services/downTimeService.js';
import './services/serverValidateService.js';
import './services/tdcService.js';
import './services/tdcService.js';
import './services/utilService.js';
// import './services/waitingRoomService.js';

import {utilModule} from './module.js';
import {NUSAnalytics} from '@nuskin/ns-util';
utilModule.service('nusAnalyticsService', function() {
    return NUSAnalytics;
});

export * from './module.js';